import api from '@/apis'
import Vuetify from '@/plugins/vuetify'

export default {
  state: {
    visibility: false,
    loading: false,
    model_info: {}
  },
  mutations: {
    RESET_BROWSE_MOTION_DIALOG(state) {
      state.visibility = false
      state.model_info = {}
    },
    SET_BROWSE_MOTION_DIALOG_VISIBILITY(state, payload) {
      state.visibility = payload
    },
    SET_BROWSE_MOTION_DIALOG_LOADING(state, payload) {
      state.loading = payload
    },
    SET_BROWSE_MOTION_DIALOG_MODEL_INFO(state, payload) {
      state.model_info = payload
    }
  },
  actions: {
    async initBrowseMotionDialog({ commit }) {
      try {
        commit('SET_BROWSE_MOTION_DIALOG_VISIBILITY', true)
        commit('SET_BROWSE_MOTION_DIALOG_LOADING', true)
        commit('SET_SNACKBAR', { status: true, color: 'loading', text: Vuetify.locale.t('$vuetify.__SnackBar.loading', ''), loading: true })

        const response = await api.getAvatarMotionPreview()
        if (response.data.success) {
          commit('SET_SNACKBAR', { status: true, color: 'success', text: Vuetify.locale.t('$vuetify.__SnackBar.success', ''), icon: 'check', timeout: '2000' })
          commit('SET_BROWSE_MOTION_DIALOG_MODEL_INFO', response.data.data)
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_BROWSE_MOTION_DIALOG_LOADING', false)
      }
    }
  }
}
